import { render, staticRenderFns } from "./CGVPopup.vue?vue&type=template&id=61c6ed70&scoped=true&"
import script from "./CGVPopup.vue?vue&type=script&lang=ts&"
export * from "./CGVPopup.vue?vue&type=script&lang=ts&"
import style0 from "./CGVPopup.vue?vue&type=style&index=0&id=61c6ed70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c6ed70",
  null
  
)

export default component.exports